import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import type { Comment } from '@go-modules/interfaces/comments/comment';
import { FormatTimePipe } from '@go-modules/pipes/format-time/format-time.pipe';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogData } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';

@Component({
	selector: 'feedback-time-editor',
	templateUrl: './feedback-time-editor.component.html',
	styleUrls: ['./feedback-time-editor.component.scss'],
	standalone: false
})
export class FeedbackTimeEditorComponent implements OnInit, AfterViewInit {
	@Input() public duration: number;
	@Input() public comment: Comment;
	@Output() public onSave = new EventEmitter<number>();
	@Output() public onClose = new EventEmitter();
	public time: number;
	@ViewChild('sliderThumb') public sliderThumb: MatSliderThumb;

	constructor (
		private dialog: MatDialog,
		private translate: TranslateService
	) {}

	public ngOnInit () {
		this.time = Number(this.comment.time);
	}

	public ngAfterViewInit () {
		this.sliderThumb.focus();
	}

	public formatLabel (value: number) {
		const timePipe = new FormatTimePipe();
		return timePipe.transform(value);
	}

	public save () {
		if (this.time === this.comment.time) {
			this.onClose.emit();
		} else {
			this.onSave.emit(this.time);
		}
	}

	public cancel () {
		if (this.time === this.comment.time) {
			return this.onClose.emit();
		}
		const dialogRef: MatDialogRef<ConfirmDialogComponent, any> = this.dialog.open(ConfirmDialogComponent, {
			data: {
				title: this.translate.instant('activity-settings_controller-unsaved-changes'),
				message: this.translate.instant('feedback-creator_discard-message'),
				confirmText: this.translate.instant('common_discard-changes')
			} as ConfirmDialogData
		});

		dialogRef.afterClosed().subscribe((confirm) => {
			if (confirm) {
				this.onClose.emit();
			}
		});
	}

	public increment () {
		const newTime = Math.min(this.time + 1000, this.duration);
		this.time = newTime;
	}

	public decrement () {
		const newTime = Math.max(this.time - 1000, 0);
		this.time = newTime;
	}

	public updateTime (value: number) {
		this.time = value;
	}

	public getThumbPosition (slider?: MatSlider): string {
		if (!slider) return '50%';

		const percent = this.time / this.duration;
		const sliderRect = slider._elementRef.nativeElement.getBoundingClientRect();
		const trackWidth = sliderRect.width - 24;
		const pixelPosition = percent * trackWidth + 12;

		return `${pixelPosition}px`;
	}
}
